import React from 'react'
import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateExcelTemplate = loadable(
  () => import("../../components/ExcelTemplate/CreateTemplate")
);


const CreateExcel = () => {
   const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [""],
  });

const handleCreate = async (values: any, setError: any) => {
    let formData = {
      ...values,
    };
    const url = `${APIS.COLUMN_DEFINITION_RESET}`;
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Template
        </span>
      </div>
      <CreateExcelTemplate
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateExcel
